(() => {
  function initialize() {
    document.querySelectorAll('.sparkle-pilot[data-replacement-ui]').forEach(root => {
      if (root.dataset.metalControlsReady) return;
      const colours = root.querySelector('[data-metal-colours]');
      if (!colours) return;
      root.dataset.metalControlsReady = 'true';
      function update() {
        const selected = root.querySelector('input[name^="pilot-metal"]:checked');
        const platinum = selected?.value === 'Platinum';
        colours.hidden = platinum;
        colours.disabled = platinum;
      }
      root.addEventListener('change', event => {
        if (event.target.matches('input[name^="pilot-metal"]')) update();
      });
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  function initialize() {
    document.querySelectorAll('.sp-contact[data-replacement-contact]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const dialog = section.querySelector('dialog');
      function open(channel) {
        if (typeof dialog.showModal !== 'function') return false;
        dialog.querySelectorAll('[data-qr-panel]').forEach(panel => { panel.hidden = panel.dataset.qrPanel !== channel; });
        dialog.querySelector('[data-contact-dialog-title]').textContent = channel === 'whatsapp' ? section.closest('[data-replacement-ui-shell]').getAttribute('data-message-0') : section.closest('[data-replacement-ui-shell]').getAttribute('data-message-1');
        dialog.showModal();
        return true;
      }
      section.querySelectorAll('[data-qr-channel]').forEach(button => button.addEventListener('click', () => open(button.dataset.qrChannel)));
      section.querySelectorAll('[data-contact-channel]').forEach(link => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (window.matchMedia('(pointer:fine) and (min-width: 768px)').matches && open(link.dataset.contactChannel)) event.preventDefault();
      }));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();


(() => {
  function initialize() {
    document.querySelectorAll('.sparkle-pilot[data-replacement-ui]').forEach(root => {
      const button = root.querySelector('[data-request-quote]');
      if (!button || button.dataset.ready) return;
      button.dataset.ready = 'true';
      const dialog = root.querySelector('[data-quote-dialog]');
      const message = dialog.querySelector('[data-quote-message]');
      const text = dialog.querySelector('[data-quote-text]');
      const fallback = dialog.querySelector('[data-quote-fallback]');
      const engravingToggle = root.querySelector('[data-engraving-toggle]');
      const engravingInput = root.querySelector('[data-engraving-text]');
      function syncEngraving() {
        const enabled = engravingToggle.checked;
        root.querySelector('[data-engraving-field]').hidden = !enabled;
        engravingInput.disabled = !enabled;
        engravingToggle.setAttribute('aria-expanded', String(enabled));
      }
      if (engravingToggle) {
        engravingToggle.addEventListener('change', syncEngraving);
        syncEngraving();
      }
      function configuration() {
        const metal = root.querySelector('input[name^="pilot-metal"]:checked')?.value || root.closest('[data-replacement-ui-shell]').getAttribute('data-message-2');
        const colour = root.querySelector('input[name="properties[Metal colour]"]:checked')?.value || root.closest('[data-replacement-ui-shell]').getAttribute('data-message-2');
        const lines = [root.closest('[data-replacement-ui-shell]').getAttribute('data-message-3'), '', root.querySelector('h1').textContent.trim(), root.closest('[data-replacement-ui-shell]').getAttribute('data-message-4') + root.dataset.reference, root.closest('[data-replacement-ui-shell]').getAttribute('data-message-5') + root.dataset.origin, root.dataset.weightLabel + ': ' + root.dataset.weight + ' ct', root.closest('[data-replacement-ui-shell]').getAttribute('data-message-6') + (root.querySelector('input[name^="pilot-metal"]:checked')?.closest('label')?.textContent.trim() || metal)]; if (root.dataset.shape) lines.push(root.closest('[data-replacement-ui-shell]').getAttribute('data-message-7') + root.dataset.shape);
        if (metal !== 'Platinum') lines.push(root.closest('[data-replacement-ui-shell]').getAttribute('data-message-8') + (root.querySelector('input[name="properties[Metal colour]"]:checked')?.closest('label')?.textContent.trim() || colour));
        const ringSize = root.querySelector('[data-ring-size]')?.value.trim();
        if (root.querySelector('[data-ring-size]')) lines.push(ringSize ? root.closest('[data-replacement-ui-shell]').getAttribute('data-message-9') + ringSize : root.closest('[data-replacement-ui-shell]').getAttribute('data-message-10'));
        if (engravingToggle?.checked) lines.push(root.closest('[data-replacement-ui-shell]').getAttribute('data-message-11') + (engravingInput.value.trim() || root.closest('[data-replacement-ui-shell]').getAttribute('data-message-12')));
        if (location.protocol === 'https:' || location.protocol === 'http:') lines.push(root.closest('[data-replacement-ui-shell]').getAttribute('data-message-13') + location.origin + location.pathname);
        return lines.join('\n');
      }
      async function copy() {
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text.value);
            return true;
          }
        } catch (_) { /* Offer the visible manual copy field when access is denied. */ }
        try {
          fallback.hidden = false;
          text.focus();
          text.select();
          return document.execCommand('copy') === true;
        } catch (_) { return false; }
      }
      async function copyAndReport() {
        const success = await copy();
        fallback.hidden = success;
        message.textContent = success ? root.closest('[data-replacement-ui-shell]').getAttribute('data-message-14') : root.closest('[data-replacement-ui-shell]').getAttribute('data-message-15');
        if (success) dialog.querySelector('[data-quote-whatsapp]').focus();
      }
      button.addEventListener('click', async () => {
        text.value = configuration();
        fallback.hidden = true;
        message.textContent = root.closest('[data-replacement-ui-shell]').getAttribute('data-message-16');
        dialog.showModal();
        await copyAndReport();
      });
      dialog.querySelector('[data-quote-copy]').addEventListener('click', copyAndReport);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  function refreshDelivery() {
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Dubai',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
    const value = type => Number(parts.find(p => p.type === type).value);
    document.querySelectorAll('[data-delivery-date]').forEach(node => {
      const days = node.getAttribute('data-delivery-date') === 'end' ? 12 : 10;
      const arrival = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + days));
      node.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {timeZone:'UTC',month:'short',day:'numeric'}).format(arrival);
      node.setAttribute('datetime', arrival.toISOString().slice(0,10));
    });
  }
  refreshDelivery();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshDelivery(); });
  document.addEventListener('shopify:section:load', refreshDelivery);
  setInterval(refreshDelivery, 60000);
})();
